import { api } from "../api";

export interface Location {
  id: string;
  tenantId: string;
  name: string;
  code?: string | null;
  description?: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateLocationDto {
  name: string;
  code?: string;
  description?: string;
  isActive?: boolean;
}

export type UpdateLocationDto = Partial<CreateLocationDto>;

export const locationsApi = {
  /**
   * Get all locations for the current tenant (authenticated)
   */
  getAll: async (includeInactive = false): Promise<Location[]> => {
    const response = await api.get("/locations", {
      params: { includeInactive },
    });
    return response.data;
  },

  /**
   * Get a single location by ID
   */
  getById: async (id: string): Promise<Location> => {
    const response = await api.get(`/locations/${id}`);
    return response.data;
  },

  /**
   * Create a new location
   */
  create: async (data: CreateLocationDto): Promise<Location> => {
    const response = await api.post("/locations", data);
    return response.data;
  },

  /**
   * Update an existing location
   */
  update: async (id: string, data: UpdateLocationDto): Promise<Location> => {
    const response = await api.put(`/locations/${id}`, data);
    return response.data;
  },

  /**
   * Delete a location
   * @param id - Location ID
   * @param hardDelete - If true, permanently delete. If false or undefined, soft delete (set inactive).
   */
  delete: async (id: string, hardDelete?: boolean): Promise<void> => {
    const params = hardDelete ? { hardDelete: "true" } : {};
    await api.delete(`/locations/${id}`, { params });
  },
};
